module.exports = __webpack_public_path__ + "media/images/hero-mobile-2-8827c9269c6b674b223c6f62fa5f3054.jpg";